
import { useState } from 'react';
import { PortfolioItem, ExperienceItem } from '@/hooks/useProfile';

// Hook for managing skills and languages
export const useProfileItems = (
  initialSkills: string[] | null = [],
  initialLanguages: string[] | null = []
) => {
  const [skills, setSkills] = useState<string[] | null>(initialSkills);
  const [languages, setLanguages] = useState<string[] | null>(initialLanguages);
  const [newSkill, setNewSkill] = useState('');
  const [newLanguage, setNewLanguage] = useState('');

  const addSkill = () => {
    if (!newSkill.trim()) return;
    
    const updatedSkills = [...(skills || []), newSkill.trim()];
    setSkills(updatedSkills);
    setNewSkill('');
  };

  const removeSkill = (index: number) => {
    const updatedSkills = [...(skills || [])];
    updatedSkills.splice(index, 1);
    setSkills(updatedSkills);
  };

  const addLanguage = () => {
    if (!newLanguage.trim()) return;
    
    const updatedLanguages = [...(languages || []), newLanguage.trim()];
    setLanguages(updatedLanguages);
    setNewLanguage('');
  };

  const removeLanguage = (index: number) => {
    const updatedLanguages = [...(languages || [])];
    updatedLanguages.splice(index, 1);
    setLanguages(updatedLanguages);
  };

  return {
    skills,
    languages,
    newSkill,
    newLanguage,
    setNewSkill,
    setNewLanguage,
    addSkill,
    removeSkill,
    addLanguage,
    removeLanguage
  };
};

// Hook specifically for portfolio and experience items
export const usePortfolioExperience = (
  initialPortfolio: PortfolioItem[] | null = [],
  initialExperience: ExperienceItem[] | null = []
) => {
  const [portfolioItems, setPortfolioItems] = useState<PortfolioItem[] | null>(initialPortfolio);
  const [experienceItems, setExperienceItems] = useState<ExperienceItem[] | null>(initialExperience);

  const handlePortfolioChange = (items: PortfolioItem[]) => {
    setPortfolioItems(items);
  };

  const handleExperienceChange = (items: ExperienceItem[]) => {
    setExperienceItems(items);
  };

  return {
    portfolioItems,
    experienceItems,
    handlePortfolioChange,
    handleExperienceChange
  };
};
